import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link, withRouter } from 'react-router'
import classnames from 'classnames'

import DropdownMenu from './DropdownMenu'

@withRouter
@inject('websites')
@observer
export default class TopNav extends Component {
  shouldComponentUpdate() { return true }

  renderWebsiteLabel() {
    if (this.props.websites.pendingCount) {
      return (
        <span>
          <span className="notification-count-bubble notification-bubble-orange"></span>
          Websites
        </span>
      )
    } else {
      return <span>Websites</span>
    }
  }

  adminDropdownClass() {
    const { router } = this.props
    return classnames('website-nav', {
      'active': router.location.pathname.match(/^\/admin\/*/)
    })
  }

  manageDropdownClass() {
    const { router } = this.props
    return classnames('website-nav', {
      'active': router.location.pathname.match(/^\/manage\/*/)
    })
  }

  render() {
    const { auth, auth: { user } } = this.props

    if (!user) return null

    return (
      <nav className="header">
        <div className="menu top">
          <Link to="/" className="logo"/>

          <DropdownMenu menuClass="user" menuTitle="My Account">
            <div className="user-info">
              <div className="label">Logged in as:</div>
              <div className="name">{user.name}</div>
            </div>
            <div className="separator"></div>
            <a className="logout" href="#" onClick={() => auth.logout()}>Log Out</a>
          </DropdownMenu>
        </div>

        <div className="menu secondary website">
          <Link to="/teams" activeClassName="active">Teams</Link>
          <Link to="/websites" activeClassName="active">{this.renderWebsiteLabel()}</Link>
          <Link to="/orders" activeClassName="active">Orders</Link>
          <Link to="/trialing" activeClassName="active">Trialing</Link>
          { user.admin ? (<DropdownMenu menuClass={this.adminDropdownClass()} menuTitle="Admin">
            <Link to="/admin/reports">Reports</Link>
            <Link to="/admin/resellers">Resellers</Link>
            <Link to="/admin/mls">MLS</Link>
            <Link to="/admin/add-customer">New Customer</Link>
          </DropdownMenu>) : (<DropdownMenu menuClass={this.manageDropdownClass()} menuTitle="Manage">
            <Link to="/manage/add-reseller">New Reseller</Link>
            {this.props.auth.user.broker ? (
              <Link to="/manage/add-customer">New Customer</Link>
            ) : null}
          </DropdownMenu>) }
        </div>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/TopNav.js